import React from 'react';
import './MonkeyLoader.css';

/**
 * MonkeyLoader - Animated loading badge with walking monkey
 *
 * Used as Suspense fallback for lazy-loaded routes (via PageLoader).
 * Shows the jade pendant badge with walking monkey and bouncing dots.
 */
export const MonkeyLoader: React.FC = () => {
  return (
    <div className="monkey-loader">
      <div className="monkey-loader__badge">
        <img
          src="/singequimarcheorange.png"
          alt="Loading..."
          className="monkey-loader__monkey"
        />
        <div className="monkey-loader__dots">
          <span></span><span></span><span></span>
        </div>
      </div>
    </div>
  );
};

export default MonkeyLoader;
